import { twMerge } from 'tailwind-merge';
import { Button } from '@/components/shared/button';
import { GoogleLogo } from '@/components/shared/custom-icons';

/**
 * Google OAuth button. White surface with a hairline border so it reads as a
 * control against the page fill, matching the account field above it.
 */
export function GoogleButton({
  className,
  isLoading = false,
  disabled = false,
  children,
  ...props
}) {
  return (
    <Button
      disabled={disabled || isLoading}
      className={twMerge(
        'w-full gap-2 rounded-full border border-beautifi-blue-100/75 bg-base-100 text-base-content shadow-beautifi',
        'transition-colors hover:border-info hover:bg-base-100',
        'disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...props}
    >
      {isLoading ? (
        <span className="loading loading-spinner loading-sm" />
      ) : (
        <GoogleLogo className="w-5 h-5" />
      )}
      {children}
    </Button>
  );
}
